/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';

import { SortableArrayField, ContentModuleModal } from '@molecules';
import { NO_MARGIN_BOTTOM } from '@constants';

import Form from '../Form';

import AddVideoForm from './AddVideoForm';
import Item from './item';
import VideoItem from './VideoItem';
import { VIDEOS } from './constant';

const VideoCarousel = ({ visible = true, onSubmit, hide, previewImg, onDelete, initialValues, errors }) => {
  const [form] = Form.useForm([VIDEOS]);

  const handleClose = () => {
    form.resetFields();
    hide();
  };

  const handleSubmit = (values) => {
    onSubmit(values);
    handleClose();
  };

  const handleAdd = React.useCallback(
    (slide) => {
      form.setFields([
        {
          name: VIDEOS.name,
          value: [slide, ...(form.getFieldValue(VIDEOS.name) || [])],
        },
      ]);
    },
    [form],
  );
  return (
    <ContentModuleModal
      visible={visible}
      title="Video carousel"
      subtitle="Choose up to 20 videos to show in a carousel"
      okText={onDelete ? 'SAVE CHANGES' : 'ADD VIDEO CAROUSEL'}
      onCancel={handleClose}
      onSubmit={form.submit}
      onDelete={onDelete}
      heroImageSrc={previewImg}
      errors={errors}
    >
      <AddVideoForm onSubmit={handleAdd} />
      <Form form={form} onSerializedFinish={handleSubmit} hideRequiredMark initialValues={initialValues}>
        <SortableArrayField style={NO_MARGIN_BOTTOM} withPlaceholder withCount form={form} {...VIDEOS}>
          {(video) => <VideoItem video={video} />}
        </SortableArrayField>
      </Form>
    </ContentModuleModal>
  );
};

VideoCarousel.Item = Item;

export default VideoCarousel;
